var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alerts"},_vm._l((_vm.alerts),function(type,index){return _c('Alert',{key:index,attrs:{"type":type.type,"icon":type.icon}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }